import request from "./../utils/request";
import _ from "lodash";
import log2 from "../utils/log2";

const log = log2("VOICE_AGENT_API");
const cache = {}
export const VOICE_AGENT_API = {
    agents: {
        /**
         * @return {Promise<{agent_id: string, agent_name: string, voice_id: string, backchannel_words: string[], ambient_sound: string, is_published: boolean, backchannel_frequency: number, language: string, version: number, normalize_for_speech: boolean, voicemail_detection_timeout_ms: number, responsiveness: number, volume: number, post_call_analysis_model: string, voice_model: string, interruption_sensitivity: number, voice_speed: number, opt_out_sensitive_data_storage: boolean, last_modification_timestamp: number, voice_temperature: number, enable_backchannel: boolean, response_engine: {type: string, llm_id: string, version: number}, max_call_duration_ms: number}|AxiosResponse<any>>}
         */
        list: async (lite = false,useCache = false) => {
            const cacheKey = `agents.list.${lite}`;
            if (useCache && cache[cacheKey]) {
                return cache[cacheKey];
            }
            log("agents.list");
            const response = await request({
                url: lite ? `/voice-agent/agents?lite=true` : `/voice-agent/agents`,
                method: "get",
            }).then((response) => response.data);
            cache[cacheKey] = response;
            return response;
        },

        get: (agentId,useCache=false) => {
            log("agents.get", { agentId });
            const cacheKey = `agents.get.${agentId}`;
            if (useCache && cache[cacheKey]) {
                return cache[cacheKey];
            }
            return request({
                url: `/voice-agent/agents/${agentId}`,
                method: "get",
            }).then((response) => response.data);
        },

        create: (agentData) => {
            log("agents.create", agentData);
            return request.post(`/voice-agent/agents`, agentData).then((response) => response.data);
        },

        update: (agentId, agentData) => {
            log("agents.update", { agentId, agentData });
            return request.patch(`/voice-agent/agents/${agentId}`, agentData).then((response) => response.data);
        },

        delete: (agentId) => {
            log("agents.delete", { agentId });
            return request({
                url: `/voice-agent/agents/${agentId}`,
                method: "delete",
            }).then((response) => response.data);
        },
    },

    calls: {
        createWeb: (callData) => {
            log("calls.createWeb", callData);
            return request.post(`/voice-agent/calls/web`, callData).then((response) => response.data);
        },

        createPhone: (callData) => {
            log("calls.createPhone", callData);
            return request.post(`/voice-agent/calls/phone`, callData).then((response) => response.data);
        },

        get: (callId) => {
            log("calls.get", { callId });
            return request({
                url: `/voice-agent/calls/${callId}`,
                method: "get",
            }).then((response) => response.data);
        },

        list: (options) => {
            log("calls.list", options);
            return request.post(`/voice-agent/calls/list`, options).then((response) => response.data);
        },
        
        listBatchCalls: () => {
            log("calls.listBatchCalls");
            return request({
                url: `/voice-agent/calls/batch`,
                method: "get",
            }).then((response) => response.data);
        },
        
        createBatchCall: (batchCallData) => {
            log("calls.createBatchCall", batchCallData);
            return request.post(`/voice-agent/calls/batch`, batchCallData).then((response) => response.data);
        },
    },

    numbers: {
        list: (useCache=false) => {
            log("numbers.list");
            const cacheKey = `numbers.list`;
            if (useCache && cache[cacheKey]) {
                return cache[cacheKey];
            }
            return request({
                url: `/voice-agent/numbers`,
                method: "get",
            }).then((response) => response.data);
        },

        get: (phoneNumber) => {
            log("numbers.get", { phoneNumber });
            return request({
                url: `/voice-agent/numbers/${phoneNumber}`,
                method: "get",
            }).then((response) => response.data);
        },

        create: (numberData) => {
            log("numbers.create", numberData);
            return request.post(`/voice-agent/numbers`, numberData).then((response) => response.data);
        },

        import: (importData) => {
            log("numbers.import", importData);
            return request.post(`/voice-agent/numbers/import`, importData).then((response) => response.data);
        },

        update: (phoneNumber, updateData) => {
            log("numbers.update", { phoneNumber, updateData });
            return request.patch(`/voice-agent/numbers/${phoneNumber}`, updateData).then((response) => response.data);
        },

        delete: (phoneNumber) => {
            log("numbers.delete", { phoneNumber });
            return request({
                url: `/voice-agent/numbers/${phoneNumber}`,
                method: "delete",
            }).then((response) => response.data);
        },
    },

    llms: {
        list: () => {
            log("llms.list");
            return request({
                url: `/voice-agent/llms`,
                method: "get",
            }).then((response) => response.data);
        },

        get: (llmId) => {
            log("llms.get", { llmId });
            return request({
                url: `/voice-agent/llms/${llmId}`,
                method: "get",
            }).then((response) => response.data);
        },

        create: (llmData) => {
            log("llms.create", llmData);
            return request.post(`/voice-agent/llms`, llmData).then((response) => response.data);
        },

        update: (llmId, llmData) => {
            log("llms.update", { llmId, llmData });
            return request.patch(`/voice-agent/llms/${llmId}`, llmData).then((response) => response.data);
        },

        delete: (llmId) => {
            log("llms.delete", { llmId });
            return request({
                url: `/voice-agent/llms/${llmId}`,
                method: "delete",
            }).then((response) => response.data);
        },
    },

    knowledgeBases: {
        list: () => {
            log("knowledgeBases.list");
            return request({
                url: `/voice-agent/knowledgebases`,
                method: "get",
            }).then((response) => response.data);
        },

        get: (knowledgeBaseId) => {
            log("knowledgeBases.get", { knowledgeBaseId });
            return request({
                url: `/voice-agent/knowledgebases/${knowledgeBaseId}`,
                method: "get",
            }).then((response) => response.data);
        },

        addSources: (knowledgeBaseId, sourcesData) => {
            log("knowledgeBases.addSources", { knowledgeBaseId, sourcesData });
            
            const formData = new FormData();
            
            // Metinleri ekle
            if (sourcesData.knowledge_base_texts && Array.isArray(sourcesData.knowledge_base_texts)) {
                formData.append("knowledge_base_texts", JSON.stringify(sourcesData.knowledge_base_texts));
            }
            
            // URL'leri ekle
            if (sourcesData.knowledge_base_urls && Array.isArray(sourcesData.knowledge_base_urls)) {
                formData.append("knowledge_base_urls", JSON.stringify(sourcesData.knowledge_base_urls));
            }
            
            // Dosyaları ekle
            if (sourcesData.knowledge_base_files && Array.isArray(sourcesData.knowledge_base_files)) {
                sourcesData.knowledge_base_files.forEach((file, index) => {
                    formData.append("files", file);
                });
            }
            
            return request
                .post(`/voice-agent/knowledgebases/${knowledgeBaseId}/sources`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => response.data);
        },

        create: (knowledgeBaseData) => {
            log("knowledgeBases.create", knowledgeBaseData);
            
            const formData = new FormData();
            
            // Bilgi tabanı adı
            if (knowledgeBaseData.knowledge_base_name) {
                formData.append("knowledge_base_name", knowledgeBaseData.knowledge_base_name);
            }
            
            // Metinleri ekle
            if (knowledgeBaseData.knowledge_base_texts && Array.isArray(knowledgeBaseData.knowledge_base_texts)) {
                formData.append("knowledge_base_texts", JSON.stringify(knowledgeBaseData.knowledge_base_texts));
            }
            
            // URL'leri ekle
            if (knowledgeBaseData.knowledge_base_urls && Array.isArray(knowledgeBaseData.knowledge_base_urls)) {
                formData.append("knowledge_base_urls", JSON.stringify(knowledgeBaseData.knowledge_base_urls));
            }
            
            // Dosyaları ekle
            if (knowledgeBaseData.knowledge_base_files && Array.isArray(knowledgeBaseData.knowledge_base_files)) {
                knowledgeBaseData.knowledge_base_files.forEach((file, index) => {
                    formData.append("files", file);
                });
            }
            
            // Otomatik yenileme
            if (knowledgeBaseData.enable_auto_refresh !== undefined) {
                formData.append("enable_auto_refresh", knowledgeBaseData.enable_auto_refresh);
            }
            
            return request.post(`/voice-agent/knowledgebases`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => response.data);
        },

        delete: (knowledgeBaseId) => {
            log("knowledgeBases.delete", { knowledgeBaseId });
            return request({
                url: `/voice-agent/knowledgebases/${knowledgeBaseId}`,
                method: "delete",
            }).then((response) => response.data);
        },

        deleteSource: (knowledgeBaseId, sourceId) => {
            log("knowledgeBases.deleteSource", { knowledgeBaseId, sourceId });
            return request({
                url: `/voice-agent/knowledgebases/${knowledgeBaseId}/sources/${sourceId}`,
                method: "delete",
            }).then((response) => response.data);
        },
    },

    voices: {
        list: () => {
            log("voices.list");
            return request({
                url: `/voice-agent/voices`,
                method: "get",
            }).then((response) => response.data);
        },

        get: (voiceId) => {
            log("voices.get", { voiceId });
            return request({
                url: `/voice-agent/voices/${voiceId}`,
                method: "get",
            }).then((response) => response.data);
        },
        
        clone: (formData) => {
            log("voices.clone");
            
            return request.post(`/voice-agent/voices/clone`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => response.data);
        },
        
        searchCommunity: (searchQuery) => {
            log("voices.searchCommunity", { searchQuery });
            
            return request({
                url: `/voice-agent/voices/search-community`,
                method: "post",
                data: { search_query: searchQuery }
            }).then((response) => response.data);
        },
        
        addCommunity: (providerVoiceId, publicUserId, voiceName) => {
            log("voices.addCommunity", { providerVoiceId, publicUserId, voiceName });
            
            return request({
                url: `/voice-agent/voices/add-community`,
                method: "post",
                data: {
                    provider_voice_id: providerVoiceId,
                    public_user_id: publicUserId,
                    voice_name: voiceName
                }
            }).then((response) => response.data);
        }
    },

    webAgent: {
        getSettings: (agentId) => {
            log("webAgent.getSettings", { agentId });
            return request({
                url: `/voice-agent/web-agent/${agentId}`,
                method: "get",
            }).then((response) => response.data);
        },

        updateSettings: (agentId, settingsData) => {
            log("webAgent.updateSettings", { agentId, settingsData });
            return request.patch(`/voice-agent/web-agent/${agentId}`, settingsData).then((response) => response.data);
        },
        
        createWebAgent: (createData) => {
            log("webAgent.createWebAgent", createData);
            return request.post(`/voice-agent/web-agent`, createData).then((response) => response.data);
        },
        
        deleteWebAgent: (agentId) => {
            log("webAgent.deleteWebAgent", { agentId });
            return request({
                url: `/voice-agent/web-agent/${agentId}`,
                method: "delete",
            }).then((response) => response.data);
        },

        getPublicSettings: (siteId, agentId) => {
            log("webAgent.getPublicSettings", { siteId, agentId });
            return request({
                url: `/voice-agent/web-agent/public/${siteId}/${agentId}`,
                method: "get",
            }).then((response) => response.data);
        },
        
        getPublicBarSettings: (siteId, agentId) => {
            log("webAgent.getPublicBarSettings", { siteId, agentId });
            return request({
                url: `/voice-agent/web-agent/public-bar/${siteId}/${agentId}`,
                method: "get",
            }).then((response) => response.data);
        },
        
        updatePublicBarSettings: (siteId, agentId, settingsData) => {
            log("webAgent.updatePublicBarSettings", { siteId, agentId, settingsData });
            return request.post(`/voice-agent/web-agent/public-bar/${siteId}/${agentId}`, settingsData).then((response) => response.data);
        },
        
        
    },

    chats: {
        /**
         * Create a new chat session for LLM testing
         * @param {string} agentId - Agent ID to use for the chat
         * @param {object} [metadata] - Optional metadata object
         * @param {object} [retellLlmDynamicVariables] - Optional dynamic variables
         * @returns {Promise<object>} - Created chat object
         */
        create: (agentId, metadata, retellLlmDynamicVariables) => {
            log("chats.create", { agentId, metadata, retellLlmDynamicVariables });
            return request.post(`/voice-agent/chats`, {
                agent_id: agentId,
                metadata: metadata,
                retell_llm_dynamic_variables: retellLlmDynamicVariables,
            }).then((response) => response.data);
        },

        /**
         * Send a message and get agent response
         * @param {string} chatId - Chat ID
         * @param {string} content - User message content
         * @returns {Promise<object>} - Chat completion response with messages array
         */
        createCompletion: (chatId, content) => {
            log("chats.createCompletion", { chatId, content });
            return request.post(`/voice-agent/chats/${chatId}/completion`, {
                content: content,
            }).then((response) => response.data);
        },

        /**
         * Get chat details
         * @param {string} chatId - Chat ID
         * @returns {Promise<object>} - Chat details object
         */
        get: (chatId) => {
            log("chats.get", { chatId });
            return request({
                url: `/voice-agent/chats/${chatId}`,
                method: "get",
            }).then((response) => response.data);
        },

        /**
         * Update chat metadata and dynamic variables
         * @param {string} chatId - Chat ID
         * @param {object} [metadata] - Optional metadata object
         * @param {object} [overrideDynamicVariables] - Optional dynamic variables to override
         * @returns {Promise<object>} - Updated chat object
         */
        update: (chatId, metadata, overrideDynamicVariables) => {
            log("chats.update", { chatId, metadata, overrideDynamicVariables });
            return request.patch(`/voice-agent/chats/${chatId}`, {
                metadata: metadata,
                override_dynamic_variables: overrideDynamicVariables,
            }).then((response) => response.data);
        },

        /**
         * End an ongoing chat session
         * @param {string} chatId - Chat ID
         * @returns {Promise<object>} - Ended chat object
         */
        end: (chatId) => {
            log("chats.end", { chatId });
            return request.patch(`/voice-agent/chats/${chatId}/end`, {}).then((response) => response.data);
        },

        /**
         * Playground completion - send cumulative transcript and get agent response
         * Used for LLM Chat Test with cumulative message history
         * @param {string} agentId - Agent ID
         * @param {Array} transcript - Cumulative message transcript
         * @param {object} [dynamicVariables] - Dynamic variables
         * @param {Array} [toolMocks] - Tool mock responses (default: [])
         * @param {string} [currentState] - Current state (default: "")
         * @param {boolean} [callEnded] - Whether call has ended (default: false)
         * @returns {Promise<object>} - Response with messages array and knowledge_base_retrieved_contents
         */
        playgroundCompletion: (agentId, transcript, dynamicVariables, toolMocks, currentState, callEnded) => {
            log("chats.playgroundCompletion", { agentId, transcriptLength: transcript ? transcript.length : 0 });
            return request.post(`/voice-agent/playground/${agentId}/completion`, {
                transcript: transcript || [],
                dynamic_variables: dynamicVariables || {},
                tool_mocks: toolMocks || [],
                current_state: currentState || "",
                call_ended: callEnded === true,
            }).then((response) => response.data);
        },
    },
};
